import { render, staticRenderFns } from "./CourseHowVideo.vue?vue&type=template&id=fbccc29c&scoped=true&"
import script from "./CourseHowVideo.vue?vue&type=script&lang=js&"
export * from "./CourseHowVideo.vue?vue&type=script&lang=js&"
import style0 from "./CourseHowVideo.vue?vue&type=style&index=0&lang=css&"
import style1 from "./CourseHowVideo.vue?vue&type=style&index=1&id=fbccc29c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fbccc29c",
  null
  
)

export default component.exports